export const DATADOG_CLIENT_TOKEN = process.env.DATADOG_CLIENT_TOKEN ?? null;

export const REDO_API_URL = process.env.REDO_API_URL ?? "http://localhost:8888";
// console.log("REDO_API_URL 12: ", REDO_API_URL);
